<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import accidentAPI from "@/services/standards/accident/accidentAPI";
import itemsAPI from "@/services/standards/accident/itemsAPI";
import items2API from "@/services/standards/accident/items2API";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import ScoreAPI from "@/services/standards/score/scoreAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import Pagination from "@/components/standard/Accident/AccidentPagination";
import DontExist from "@/components/company/components/DontExist"
/**
 * Form elements component
 */
export default {
  page: {
    title: "Reporte de los Accidentes de Trabajo y enfermedad Laboral",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    DontExist,
  },
  data() {

    return {
      title: "3.2.1 Reporte de los Accidentes de Trabajo y enfermedad Laboral ",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Reporte de los accidentes de trabajo y enfermedad laboral",
          active: true,
        },
      ],

      awesome: true,
      lista: [],
      type: [],
      subtype: [],
      listaII: [],
      file: null,
      //loading: true,

      item: null,
      itemStatus: null,
      loading: true,
      itemData: null,

      accident: {
       accident_report_types_id: null,
        report_subtypes_id: null,
        report_date: null,
        hour: null,
        description: null,
        improvement_plan: null,
        arl_report_date: null,
        file: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
        company_classification_id: this.$store.getters["company/getCompany"].company_classification_id || null,
        items_id: 32,
      },

      
      itemsAgregar:{
        companies_id: this.$store.getters["company/getCompany"].id || null,
        items_id: 32,
        status: null,
        operation: 'suma',
        company_classification_id: this.$store.getters["company/getCompany"].company_classification_id || null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      usersList: [],

      itemcheck:{
        companies_id: this.$store.getters["company/getCompany"].id || null,
        items_id: 32,

      },

      exist: false,
      cantidad: false,


    };
  },
  methods: {

   getItem() {
      CompanyItemsAPI.getStatus(this.companyID, 32)
        .then(response => {

          //this.exist = response.id ? true : false
          this.exist = response.id
          console.group('Item 32: ')
          console.log('This is the item 32: ', response)
          console.log('Is this item exist? ', this.exist)
          console.groupEnd()

        })
        .catch(error => {
          console.log(error)
        })
    },
 /*   getItem() {
      CompanyItemsAPI.getStatus(this.companyID, 32)
        .then(response => {

          this.exist = response.items_id,
          
          
          console.group('Item 32: ')
          console.log('This is the item 32: ', response)
          console.log('Is this item exist? ', this.exist)
          console.groupEnd()

        })
        .catch(error => {
          console.log(error)
        })
    },*/

    getAccidents(){
      accidentAPI.getAllAccidents(this.companyID)
        .then((response) => {
          console.log('cantidad accidentes', response)
         // this.cantidad = response.Accident_report ? false : true
         this.cantidad = response.Accident_report
          console.log(this.cantidad)
        
        })
        .catch((error) => {
          console.log(error);
        });

    },


    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {

          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              console.log(res);
              this.usersList = res
            })

        })
        .catch((error) => {
          console.log(error);
        });

    },

    getItemData() {
      ItemAPI.getItems(32)
        .then((response) => {
          console.log("Item aqui: ", response);
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

  

    goPage(page) {
      window.location.href = page
    },

    fetch() {
      this.$refs.paginator.query();
    },


    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {

CompanyItemsAPI.getStatus(this.companyID, 32)
  .then(response => {
    this.item = response || null
    this.itemStatus = response.status ? response.status : null
    console.log(`This is the item ${this.item ? this.item.items_id : null}: `, this.item)
  })
  .catch(error => {
    console.log(error)
  })
},

changeItemStatus(item, itemStatus) {

console.log(item, itemStatus)

if (item) {

  const itemChange = {
          items_id: item.items_id,
          status: itemStatus,
          operation: item.operation,
          puntation_absoluta: item.puntation_absoluta,
          puntation_relative: item.puntation_relative,
        }

  console.group('Data that will be updated')
  console.log('New item status: ', itemChange)
  console.log('CompanyID: ', this.companyID)
  console.groupEnd()

  CompanyItemsAPI.updateStatus(this.companyID, itemChange)
    .then(response => {
      console.log(response)

      if (
              response.message ===
                "item actualizado con exito, se ha sumado el valor del item , en la puntuacion" ||
              response.message === "item actualizado con exito"
            ) {
              Swal.fire({
                title: "¡Se ha actualizado el estado del ítem con éxito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            } else {
              Swal.fire({
                title: "No se ha podido actualizar el estado del ítem",
                type: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            }

    })
    .catch(error => {
      console.log(error)
    })

}

},
    /**
        * Method to know the status item.
        * @param {Number} - Item ID.
        * @param {Object} - Item to get.
        * @param {Number} -  Status item.
        */
        getStatusItem(ID, item, itemStatus) {
      CompanyItemsAPI.getStatus(this.companyID, ID)
        .then(response => {
          item = response || null
          itemStatus = response.status
          console.log(`This is the item ${item ? item.items_id : null}: `, item)
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
   * This method is used to send notification to SST user and SST company.
   * The sendNotification method import is required.
   * @param {Number} messageID - The message ID that will be associated to notification.
   * @param {Number} itemID - The item ID that will be associated to notification.
   */
   sendNotification(messageID, itemID) {
      const company = this.$store.getters["company/getCompany"]
      return sendNotification(company.id, company.id_diseno_sso, messageID, itemID)
    },


    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
  */
  goPage(page) {
      window.location.href = page
    },


    async uploadFile() {
      this.file = this.$refs.file.files[0];
      console.log(this.file);
    },

    async uploadDocument() {
      try {
        const url = `${this.accident.companies_id}/Reporte-accidentes/${this.file.name}`;
        const result = await uploadDocument(url, this.file);
        console.log(result);
        if (result) {
          this.accident.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },
    getType() {
      accidentAPI.getType()
        .then((response) => {
          let typeAccident = response.Accident_report_type;
          console.log('consulta de tipos', typeAccident);
          this.type = typeAccident
          console.log(this.type)
          
       

        })
        .catch((error) => {
          console.log(error);
          
        });
    },

    getSubType() {
      accidentAPI.getType()
        .then((response) => {
          let typeAccident = response.Accident_report_type;
          console.log('consulta de tipos', typeAccident);
          this.type = typeAccident
          console.log(this.type)
          
          this.subtype = typeAccident[0].report_subtype
          console.log(this.subtype)

          
       

        })
        .catch((error) => {
          console.log(error);
          
        });
    },

    /*changeStatusValue() {
      this.accident.accident_report_types_id = !this.accident.accident_report_types_id;
    },*/
    
    getList() {
      accidentAPI.getAllAccidentPage(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          let accidente = response.Accident_report.data;
          console.log('primera consulta', accidente);
          this.lista = accidente
          console.log(this.lista)
          
         // this.listaII= accidente[0].accident_report[0].accident_report_type,
         // console.log('segunda consulta', this.listaII)
          this.loading = false

        })
        .catch((error) => {
          console.log(error);
          
        });
    },

    save() {
      console.log('Esto es un accidente: ', this.accident);

      this.uploadDocument();

      if (this.file)
        this.accident.file = `${process.env.VUE_APP_BUCKET}/${this.accident.companies_id}/Reporte-accidentes/${this.file.name}`;

      accidentAPI.save(this.accident)
        .then((response) => {
          console.log(response);
          


           

          if (response.message === 'Accident_report creado con exito') {
           
            ScoreAPI.saveScore(this.companyID, 32)
              .then(response => {
                console.log(response)
              this.sendNotification(30, 32)
             
             
              ScoreAPI.saveScore(this.companyID, 33)
              .then(res => {
                console.log(res)
                setTimeout(() => {

              
                  Swal.fire({
                    title: "¡Se ha registrado con éxito!",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });

                 // window.location.reload()

                }, 1000)

              })
              .catch(error => {
                console.log(error)
              })

              })
              .catch(error => {
                console.log(error)
              })

          }

        })
        .catch((error) => {
          console.log(error);
          
        });

    },

    saveItems() {
      console.log('Items agregar: ', this.itemsAgregar);

      itemsAPI.save(this.itemsAgregar)
        .then((response) => {
          console.log(response);
          
          if (response.message === 'Item 32 agregado con exito para la compañia') {
       
            ScoreAPI.saveScore(this.companyID, 32)
              .then(response => {
                console.log(response)
              this.sendNotification(1, 32)

                setTimeout(() => {

                  Swal.fire({
                    title: "No han ocurrido accidentes/ o incidentes para reportar",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });

                 // window.location.reload()

                }, 1000)
            


              })
              .catch(error => {
                console.log(error)
              })
  }

        })
        .catch((error) => {
          console.log(error);
          
        });

    },

    deleteAccident(id) {

      accidentAPI.deleteAccident(id)
        .then((data) => {
          console.log(data);
          Swal.fire({
            title: "Se ha sido eliminado con exito!",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();

        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        const url = 'https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/MATRIX_RISK.xlsx'
        window.location.href = url
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
    

  },

  mounted() {
    this.getAccidents()
    this.getUsers();
    this.getItems()
    this.getItem()
    this.getList();
    this.getItemData();
    this.getType();
    this.getSubType()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if=" !loading && classificationID <= 4 ">   
          <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6 col-sm-12">

                <CheckModal>
                  <p class="text-justify">
                    Reportar ante la ARL los accidentes e incidentes  y enfermedades laborales y subir a este aplicativo, la evidencia de dicho formulario, radicado en la ARL. Estos reportes se deben realizar durante los dos días hábiles siguientes al evento. 
                    De igual manera, se deberá reportar a la EPS del colaborador accidentado. Cuando son accidentes graves o mortales, o se califica una enfermedad laboral, se deberá notificar a la Dirección Territorial del Ministerio de Trabajo.
                    Subir en un archivo comprimido todas las evidencias de estas notificaciones.
                    </p>
                </CheckModal>
              </div>

              <div class="col-6 text-right m-b-0">

                <a href="/forms/accidentes" class="btn btn-primary mx-1" id="tooltip">
                  <span class="btn-label"> <i class="mdi mdi-arrow-right-bold-outline"></i></span> Formato único de
                  reporte de presunto accidente de trabajo (FURAT)
                </a>

                <b-tooltip target="tooltip" placement="left">
                  Ir a Formato único de reporte de presunto accidente de trabajo (FURAT)
                </b-tooltip>
              </div>

            </div>

            <div class="row">
              <div class="col-6">
              </div>



              <div class="form-row col-md-6 col-sm-12 pt-1">
                <b-form-group id="example text" label-for="status" class="col-sm-12" label="Estado del ítem">
                  <b-form-select  v-on:change="changeItemStatus(item, itemStatus)" :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain class="selectpicker form-control" v-model="itemStatus">
                    <b-form-select-option value="Aprobado">
                      Aprobado
                    </b-form-select-option>
                    <b-form-select-option value="Pendiente">
                      Pendiente
                    </b-form-select-option>
                    <b-form-select-option value="No cumplido">
                      No cumplido
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>




            </div>




            <form class="form-group" @submit.prevent="save">
              <div class="form-row pt-3">
                <label class="ml-3">
                  <input type="checkbox" v-model="itemsAgregar.status" :disabled="!getRole('Crear') || !allowAccess()" @click="awesome = !awesome" id="example-2"> No han ocurrido accidentes/ o
                  incidentes para reportar
                </label>
               
              </div>

              <!--<div v-if="awesome && exist || cantidad">-->
                <div v-if="awesome">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-6" label="Empleado" label-for="employee">
                    <select id="employeeID" :disabled="!getRole('Crear') || !allowAccess()" class="form-control" v-model="accident.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                 <!-- <b-form-group id="report_type" label-for="type" class="col-sm-6" label="Tipo">
                    <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control" v-model="accident.accident_report_types_id">
                      <b-form-select-option v-for="dato in type" :key="dato.id" :value="dato.id">
                        {{ dato.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>-->

                  
                     <b-form-group label="Tipo" label-for="tipo" inline class="col-sm-4 pl-4">
                        <label class="mr-2">
                          Accidente
                        </label>
                        <input :disabled="!getRole('Crear') || !allowAccess()"
                          type="radio"  style="color: #666"  
                          :value="1"  v-model="accident.accident_report_types_id" class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                        <label class="mr-2 pl-sm-2 pl-md-0">
                          Incidente
                        </label>
                         <input :disabled="!getRole('Crear') || !allowAccess()"
                          type="radio"  :value="2" v-model="accident.accident_report_types_id"
                          class="mb-2 mr-sm-2 mb-sm-0" label="incidente" />
                          <label class="mr-2 pl-sm-2 pl-md-0">
                          Enfermedad laboral
                        </label>
                        <input :disabled="!getRole('Crear') || !allowAccess()"
                          type="radio"  :value="3"  v-model="accident.accident_report_types_id"
                          class="mb-2 mr-sm-2 mb-sm-0" label="enfermedad" />
                      </b-form-group>
                    <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type" class="col-sm-2" label="Tipo de accidente">
                    <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control" v-model="accident.report_subtypes_id">
                      <b-form-select-option v-for="tipo in subtype" :key="tipo.id" :value="tipo.id">
                        {{ tipo.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                  <b-form-group v-else id="report_type" label-for="type" class="col-sm-2" >
                    
                  </b-form-group>
               
                </div>

                <div class="form-row">

                  <b-form-group class="col-md-6" label="Fecha" label-for="input-sm">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="accident.report_date" type="date" id="input-sm" placeholder="fecha">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6" label="Hora" label-for="hora">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="accident.hour" type="time" id="hora" placeholder=""></b-form-input>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6" label="Fecha de reporte a la arl" label-for="input-sm">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="accident.arl_report_date" type="date" id="input-sm" placeholder="fecha">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Archivo" label-for="file">
                  <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file" ref="file" name="file" browse-text="Buscar"
                      :placeholder="`Selecciona un archivo...`" drop-placeholder="Suelta acá..." v-model="file"
                      @change="uploadFile" v-on:change="uploadFile">
                  </b-form-file>
                 </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-12" label="Descripción de la situación" label-for="input-sm">
                    <b-form-textarea :disabled="!getRole('Crear') || !allowAccess()" id="textarea" v-model="accident.description" rows="4"></b-form-textarea>
                  </b-form-group>


                </div>
                <div class="form-row">
                  <b-form-group class="col-md-12" label="Plan de mejora" label-for="input-sm">
                    <b-form-textarea :disabled="!getRole('Crear') || !allowAccess()" id="textarea" v-model="accident.improvement_plan" rows="4"></b-form-textarea>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                <button :disabled="!getRole('Crear') || !allowAccess()" type="submit" class="btn btn-primary">
                  Guardar
                </button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                  Cancelar
                </button>
                </div>
              </div>

              <div v-else-if="!awesome">
                <div class="form-group text-right m-b-0">
                <button :disabled="!getRole('Crear') || !allowAccess()" @click="saveItems()" type="button" class="btn btn-primary">
                  Guardar
                </button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                  Cancelar
                </button>
              </div>
              </div>

              <div v-else ="awesome">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-6" label="Empleado" label-for="employee">
                    <select id="employeeID" :disabled="!getRole('Crear') || !allowAccess()" class="form-control" v-model="accident.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>
              
                  
                     <b-form-group label="Tipo" label-for="tipo" inline class="col-sm-4 pl-4">
                        <label class="mr-2">
                          Accidente
                        </label>
                        <input :disabled="!getRole('Crear') || !allowAccess()"
                          type="radio"  style="color: #666"  
                          :value="1"  v-model="accident.accident_report_types_id" class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                        <label class="mr-2 pl-sm-2 pl-md-0">
                          Incidente
                        </label>
                         <input :disabled="!getRole('Crear') || !allowAccess()"
                          type="radio"  :value="2" v-model="accident.accident_report_types_id"
                          class="mb-2 mr-sm-2 mb-sm-0" label="incidente" />
                          <label class="mr-2 pl-sm-2 pl-md-0">
                          Enfermedad laboral
                        </label>
                        <input :disabled="!getRole('Crear') || !allowAccess()"
                          type="radio"  :value="3"  v-model="accident.accident_report_types_id"
                          class="mb-2 mr-sm-2 mb-sm-0" label="enfermedad" />
                      </b-form-group>
                    <b-form-group v-if="accident.accident_report_types_id == 1" id="report_type" label-for="type" class="col-sm-2" label="Tipo de accidente">
                    <select id="type" :disabled="!getRole('Crear') || !allowAccess()" class="form-control" v-model="accident.report_subtypes_id">
                      <b-form-select-option v-for="tipo in subtype" :key="tipo.id" :value="tipo.id">
                        {{ tipo.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                  <b-form-group v-else id="report_type" label-for="type" class="col-sm-2" >
                    
                  </b-form-group>
               
                </div>

                <div class="form-row">

                  <b-form-group class="col-md-6" label="Fecha" label-for="input-sm">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="accident.report_date" type="date" id="input-sm" placeholder="fecha">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6" label="Hora" label-for="hora">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="accident.hour" type="time" id="hora" placeholder=""></b-form-input>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-6" label="Fecha de reporte a la arl" label-for="input-sm">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" v-model="accident.arl_report_date" type="date" id="input-sm" placeholder="fecha">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-6 px-2" label="Archivo" label-for="file">
                  <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file" ref="file" name="file" browse-text="Buscar"
                      :placeholder="`Selecciona un archivo...`" drop-placeholder="Suelta acá..." v-model="file"
                      @change="uploadFile" v-on:change="uploadFile">
                  </b-form-file>
                 </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-12" label="Descripción de la situación" label-for="input-sm">
                    <b-form-textarea :disabled="!getRole('Crear') || !allowAccess()" id="textarea" v-model="accident.description" rows="4"></b-form-textarea>
                  </b-form-group>


                </div>
                <div class="form-row">
                  <b-form-group class="col-md-12" label="Plan de mejora" label-for="input-sm">
                    <b-form-textarea :disabled="!getRole('Crear') || !allowAccess()" id="textarea" v-model="accident.improvement_plan" rows="4"></b-form-textarea>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                <button :disabled="!getRole('Crear') || !allowAccess()" @click="saveItems()" type="button" class="btn btn-primary">
                  Guardar
                </button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                  Cancelar
                </button>
              </div>
              </div>


              

              <hr v-if="getRole('Consultar')" />

              <div class="table-responsive">
                <table :disabled="!getRole('Consultar') || !allowAccess()" class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                  <thead>
                    <tr>

                      <th class="text-center align-middle">Empleado</th>
                      <th class="text-center align-middle">Tipo</th>
                      <th class="text-center align-middle">Fecha</th>
                      <th class="text-center align-middle">Descripción</th>
                      <th class="text-center align-middle">Fecha ARL</th>
                      <th class="text-center align-middle">Archivo</th>
                      <th class="text-center align-middle">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr :disabled="!getRole('Consultar') || !allowAccess()" v-for="dato in lista" :key="dato.id">
                      <td class="text-center align-middle">
                        {{dato.full_name}}
                      </td>
                      <td class="text-center align-middle">
                        {{dato.accident_report.length > 0 ? dato.accident_report[0].report_type: 'Sin registro'}}
                      </td>
                      <td class="text-center align-middle">
                        {{dato.accident_report.length > 0 ? dato.accident_report[0].report_date: 'Sin registro'}}

                      </td>
                      <td class="text-center align-middle">
                        {{dato.accident_report.length > 0 ? dato.accident_report[0].description: 'Sin registro'}}

                      </td>
                      <td class="text-center align-middle">
                        {{dato.accident_report.length > 0 ? dato.accident_report[0].arl_report_date: 'Sin registro'}}

                      </td>
                      <td :disabled="!getRole('Consultar') || !allowAccess()" class="text-center align-middle">
                        <div v-if="dato.accident_report.length > 0 && dato.accident_report[0].file != null">

                          <button :disabled="!getRole('Consultar') || !allowAccess()" style=" background-color: transparent !important; border: none;" type="button"
                            @click="gotoDigitalOcean(`${dato.accident_report[0].file}`)"> <i
                              class="mdi mdi-cloud-download"></i>
                          </button>

                        </div>
                        <div v-else>
                          <h6>Sin archivo
                          </h6>
                        </div>
                      </td>
                      <td class="text-center align-middle">
                        <div class="col-sm-12">
                          <div v-if="dato.accident_report.length > 0">
                            <b-dropdown variant="primary">
                              <template v-slot:button-content>
                                <i class="mdi mdi-eye"></i>
                              </template>

                              <b-dropdown-item :disabled="!getRole('Consultar') || !allowAccess()" :to="{ path: `/forms/estandares/${dato.companies_id}/reporte-accidentes-editar/${dato.accident_report[0].id}` } ">
                                Editar</b-dropdown-item>
                              <b-dropdown-item :disabled="!getRole('Consultar') || !allowAccess()" v-on:click="deleteAccident(dato.accident_report[0].id)">Eliminar
                              </b-dropdown-item>


                            </b-dropdown>
                          </div>
                          <div v-else>
                          </div>
                        </div>
                      </td>

                    </tr>


                  </tbody>
                </table>
                <div>
                       <Pagination ref="paginator" @fetch="(items) => (lista = items)" />
                </div>

              </div>
               </form>
          </div>
        </div>
      </div>
 
            <div v-else-if=" !loading && classificationID > 3 " >
              <DontExist />
            </div>

            <div v-else-if="!loading">
              <DontExist />
            </div>
            <div v-else class="col-xl-12 text-center">
              <div class="text-center">
                <b-spinner variant="primary" label="Loading..."></b-spinner>
              </div>
            </div> 


      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>